<script lang="ts" setup>
import { ref, nextTick, inject } from "vue"; 
import { useForm, } from "@/helpers/composables/useForm";
import { route } from "ziggy-js";
import { object, string } from "yup";
import RothcoCta from "@/components/RothcoCta.vue";
import PasswordInput from "@/components/PasswordInput.vue";
let route = inject('route');
let props = defineProps({
    user: {
        type: Object,
        default(){
            return {}
        }
    },
    encryption: {
        type: String,
        default: ''
    }
});
let resetPasswordForm = useForm({
    useInertia: true,
    schema: object({
        password: string()
                .required('The password field is required')
                .test('password-strength', '', (value, ctx) => {
                    if (!value) return true;
                    let messages = [];
                    let weakPasswordMessage;
                    if (!/[A-Z]/.test(value)) messages.push('at least one uppercase letter');
                    if (!/[a-z]/.test(value)) messages.push('at least one lowercase letter');
                    if (!/[0-9]/.test(value)) messages.push('at least one number');
                    if (!/[#?!@$%^&*-]/.test(value)) messages.push('at least one special character (# ? ! @ $  % ^ & * -)');
                    if (/\s/.test(value)) messages.push('no spaces');
                    if (value.length < 8) messages.push('at least 8 characters');
                    if (/password/i.test(value)) weakPasswordMessage = 'Your password is too weak.';
                    if (messages.length || weakPasswordMessage) return ctx.createError({ message: messages.length > 0 ? `Password must contain ${messages.join(', ')}.${weakPasswordMessage ? " " + weakPasswordMessage : ""}` : weakPasswordMessage });
                    return true;
                })
                .default(""),
        password_confirmation: string().required('Password confirmation is required').test({
                name: "password_confirmation",
                message: "Password confirmation does not match",
                test: (value) => {
                    return value == resetPasswordForm.password;
                }
        }).default(''),
        encryption: string().required().default(props.encryption)
    }),
});

const resetPassword = async ()=>{
    if(resetPasswordForm.processing) return;

    await resetPasswordForm.validate();
    nextTick(()=>{
        if(Object.keys(resetPasswordForm.errors).length == 0){
            resetPasswordForm.post(route('web.change-password'));
        }
    })
}
</script>
<template>
    <div class="authorization">
    <form class="authorization-form forgot-password-form" @submit.prevent="resetPassword()">
        <div class="authorization_popup-title headline-m" >Reset Password</div>
        <PasswordInput 
            v-model="resetPasswordForm.password" 
            :errors="resetPasswordForm.errors.password" 
            id="email_password_register"
        />
        <PasswordInput 
            v-model="resetPasswordForm.password_confirmation" 
            :errors="resetPasswordForm.errors.password_confirmation" 
            id="confirm_email_password_register"
            placeholder="Confirm Password"
        />
        <RothcoCta id="resetPasswordBtn" type="submit" :disabled="resetPasswordForm.processing" ctaType="button" class="primary">
            Reset Password
        </RothcoCta>
    </form>
</div>
</template>